// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.section_a8yKS {
  margin-bottom: 8px;
  border-radius: 8px;
  transition: all 0.3s ease;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  min-height: fit-content;
  overflow: visible;
  gap: 10px;
}

.title_XgJZY {
  font-size: 18px;
  font-weight: 600;
  color: #222222;
  margin: 0px;
  padding-bottom: 0px;
  width: 100%;
  display: block;
  flex: 1 1;
  box-sizing: border-box;
}

.content_SN3lN {
  padding: 0px;
  display: flex;
  flex-direction: column;
  flex: 1 1;
  overflow: visible;
  min-height: fit-content;
  box-sizing: border-box;
  width: 100%;
}

@media (max-width: 1024px) {
  .title_XgJZY {
    margin-left: 8px;
    width: calc(100% - 8px);
    padding: 10px;
    padding-bottom: 0;
  }

  .content_SN3lN {
    padding: 12px;
    overflow: visible;
  }
}

@media (max-width: 768px) {
  .section_a8yKS {
    margin-bottom: 12px;
    overflow: visible;
  }

  .title_XgJZY {
    font-size: 1rem;
    padding: 10px 12px 0;
    margin-left: 0;
    width: 100%;
  }

  .content_SN3lN {
    padding: 12px;
    min-height: auto;
    overflow: visible;
  }
}

@media (max-width: 480px) {
  .section_a8yKS {
    margin-bottom: 16px;
    margin: 0 auto;
    overflow: visible;
  }

  .title_XgJZY {
    font-size: 0.9rem;
    padding: 8px 10px 0;
    margin-left: 0;
    width: 100%;
  }

  .content_SN3lN {
    padding: 10px;
    overflow: visible;
  }
}`, "",{"version":3,"sources":["webpack://./src/factura-customizer/components/Section/Section.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,SAAO;EACP,iBAAiB;EACjB,uBAAuB;EACvB,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE;IACE,gBAAgB;IAChB,uBAAuB;IACvB,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,oBAAoB;IACpB,cAAc;IACd,WAAW;EACb;;EAEA;IACE,aAAa;IACb,gBAAgB;IAChB,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;IACd,WAAW;EACb;;EAEA;IACE,aAAa;IACb,iBAAiB;EACnB;AACF","sourcesContent":[".section {\n  margin-bottom: 8px;\n  border-radius: 8px;\n  transition: all 0.3s ease;\n  width: 100%;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  min-height: fit-content;\n  overflow: visible;\n  gap: 10px;\n}\n\n.title {\n  font-size: 18px;\n  font-weight: 600;\n  color: #222222;\n  margin: 0px;\n  padding-bottom: 0px;\n  width: 100%;\n  display: block;\n  flex: 1 1;\n  box-sizing: border-box;\n}\n\n.content {\n  padding: 0px;\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  overflow: visible;\n  min-height: fit-content;\n  box-sizing: border-box;\n  width: 100%;\n}\n\n@media (max-width: 1024px) {\n  .title {\n    margin-left: 8px;\n    width: calc(100% - 8px);\n    padding: 10px;\n    padding-bottom: 0;\n  }\n\n  .content {\n    padding: 12px;\n    overflow: visible;\n  }\n}\n\n@media (max-width: 768px) {\n  .section {\n    margin-bottom: 12px;\n    overflow: visible;\n  }\n\n  .title {\n    font-size: 1rem;\n    padding: 10px 12px 0;\n    margin-left: 0;\n    width: 100%;\n  }\n\n  .content {\n    padding: 12px;\n    min-height: auto;\n    overflow: visible;\n  }\n}\n\n@media (max-width: 480px) {\n  .section {\n    margin-bottom: 16px;\n    margin: 0 auto;\n    overflow: visible;\n  }\n\n  .title {\n    font-size: 0.9rem;\n    padding: 8px 10px 0;\n    margin-left: 0;\n    width: 100%;\n  }\n\n  .content {\n    padding: 10px;\n    overflow: visible;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"section": `section_a8yKS`,
	"title": `title_XgJZY`,
	"content": `content_SN3lN`
};
export default ___CSS_LOADER_EXPORT___;
